
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[urlSlug]",
      function () {
        return require("private-next-pages/[urlSlug]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[urlSlug]"])
      });
    }
  